module.exports = __webpack_public_path__ + "media/stylesheets/images/recruit/thumbnail_keisuke-masuda-dd9daeeaa70c033797e2c2f497599658.png";